<script>
import { mapGetters, mapActions } from "vuex";
import InputGroup from "@/components/_Shared/InputGroup";

export default {
  components: {
    InputGroup
  },

  data() {
    return {
      preloader: false,
      donieCovered: false,
      error: "",
      email: "",
      sent: false
    };
  },

  computed: {
    ...mapGetters("user", ["update_your_data"])
  },

  methods: {
    ...mapActions("user", ["sendPasswordRecovery"]),
    async submit() {
      if (this.preloader) return;

      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          await this.sendPasswordRecovery(this.email);
          this.sent = true;
        }
      } catch (error) {
        this.error = error;
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <div class="container-center" @keyup.enter="submit">
    <div v-if="!donieCovered" class="donie">
      <img src="../../static/donie.svg" alt="Donie">
    </div>
    <div v-else class="donie-covered">
      <img src="../../static/donie-blindfolded.svg" alt="Donie olhos fechados">
    </div>

    <div class="box">
      <div class="logo">
        <img src="../../static/logo.svg" alt="Donamaid">
      </div>

      <transition name="fade" mode="out-in">
        <div v-if="sent" class="success-message">
          <img src="../../static/icon-success.svg" class="mb-20" height="70px">
          <b class="text-purple mb-5">E-MAIL ENVIADO!</b>
          <small>Foi enviado um link de redefinição de senha para o seu e-mail!</small>
        </div>

        <div v-else>
          <b class="text-purple">Esqueceu sua senha?</b> <br>
          <small
            class="text-center text-purple mb-0"
          >Digite seu e-mail abaixo que nós enviaremos um link para você redefinir sua senha.</small>

          <div class="form-group text-left">
            <input-group label="digite seu email" type="email" v-model="email"/>
          </div>

          <transition name="zoom" mode="out-in">
            <div v-if="error" class="error-bag">
              {{error}}
              <div @click="error = ''">x</div>
            </div>
          </transition>

          <div class="btn-group">
            <div
              class="btn bg-purple mt-20"
              :class="{'btn--loading': preloader}"
              @click="submit"
              tabindex="-1"
            >
              <span>enviar</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.success-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.error-bag {
  display: inline-flex;
  background: #ffcaca;
  margin-top: 15px;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 12px;
  color: var(--pink);
}

.error-bag div {
  font-size: 10px;
  margin-left: 10px;
  cursor: pointer;
}

.form-group {
  flex-direction: column;
}

.container-center {
  position: absolute;
  background: #ededed;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.box {
  width: 350px;
  margin-top: -25px;
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.donie,
.donie-covered {
  width: 440px;
  height: 200px;
  display: inherit;
  margin-top: 20px;
  z-index: 99;
}

.donie img,
.donie-covered img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.logo {
  margin: 10px 0 30px 0;
  width: 100%;
  height: 60px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.icon-user {
  background: url("../../static/icon_user.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.icon-user.has-error {
  background: url("../../static/icon_user_danger.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.icon-password {
  background: url("../../static/icon_password.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

.icon-password.has-error {
  background: url("../../static/icon_password_danger.svg") no-repeat 10px 10px;
  background-size: 20px 20px;
}

@media (max-width: 768px) {
  .box {
    width: 340px;
  }

  .donie,
  .donie-covered {
    width: 440px;
  }
}

@media (max-width: 480px) {
  .box {
    width: calc(100% - 100px);
    margin-top: -25px;
    padding: 30px;
  }

  .donie,
  .donie-covered {
    width: 300px;
  }

  .logo {
    margin: 20px 0;
  }
}

@media (max-width: 320px) {
  .box {
    margin-top: -18px;
    margin-bottom: 10px;
  }

  .donie,
  .donie-covered {
    margin-top: 0;
    width: 150px;
    height: 120px;
  }

  .logo {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ForgotMyPassword.vue